<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
    >
      <el-form-item label="类目" prop="categoryId">
        <el-select
          v-model="queryParams.categoryId"
          placeholder="请选择类目"
          clearable
          filterable
        >
          <el-option
            v-for="item in CategoryList"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称" prop="goodsName">
        <el-input
          v-model="queryParams.goodsName"
          placeholder="请输入商品名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="上架时间" prop="createTime">
        <el-date-picker
          clearable
          v-model="queryParams.createTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择上架时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="search">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8 mt10">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table
      v-loading="loading"
      :data="tableList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="类目"
        align="center"
        prop="categoryName"
        show-overflow-tooltip
      />
      <el-table-column
        label="商品名称"
        align="center"
        prop="goodsName"
        show-overflow-tooltip
      />
      <el-table-column
        label="商品库存量"
        align="center"
        prop="stockNum"
        show-overflow-tooltip
      />
      <el-table-column
        label="售价(积分)"
        align="center"
        prop="integral"
        show-overflow-tooltip
      />
      <el-table-column
        label="上架时间"
        align="center"
        prop="createTime"
        width="150"
      >
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            circle
            type="text"
            icon="el-icon-search"
            @click="handlesee(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            >修改</el-button
          >

          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改商品对话框 -->
    <el-drawer
      :title="title"
      :visible.sync="open"
      size="50%"
      append-to-body
      :wrapperClosable="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="130px"
        class="forms"
        :disabled="title == '详情'"
      >
        <el-form-item label="类目" prop="categoryId">
          <el-select
            v-model="form.categoryId"
            placeholder="请选择类目"
            clearable
            filterable
          >
            <el-option
              v-for="item in CategoryList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model="form.goodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="商品照片" prop="goodsImg">
          <el-upload
            :action="url"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :file-list="fileList"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="商品详情" prop="goodsContent">
          <editor v-model="form.goodsContent" :min-height="192" />
        </el-form-item>
        <el-form-item label="商品库存量(件)" prop="stockNum">
          <el-input
            type="number"
            v-model="form.stockNum"
            placeholder="请输入商品库存量"
          />
        </el-form-item>
        <el-form-item label="售价(积分)" prop="integral">
          <el-input
            type="number"
            v-model="form.integral"
            placeholder="请输入积分"
          />
        </el-form-item>
        <el-form-item label="商品关键字" prop="search">
          <el-input
            v-model="form.search"
            type="textarea"
            placeholder="请输入内容"
          />
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer" v-if="title != '详情'">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button size="medium" type="primary" @click="anotherHandle"
          >保存并录入下一条</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { listTable, delTable, addTable, updateTable } from "@/api/goods";
import { listTableCategory } from "@/api/category";
import $ from "jquery";
//配置文件
import config from "@/config/index";

export default {
  name: "Table",
  data() {
    return {
      openPopupFrame: false,
      url: config.apiUploadUrl,
      openPopupFrameTwo: false,
      // 类目列表
      CategoryList: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 商品表格数据
      tableList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        platformId: this.$route.query.platformId,
        pageNum: 1,
        pageSize: 10,
        categoryId: null,
        storeId: this.$route.query.storeId,
        whereStoreId: null,
        stockNum: null,
        goodsName: null,
        salePrice: null,
        likeNum: null,
        saleNum: null,
        onsaleTime: null,
        isForce: null,
        forceReason: null,
        search: null,
      },
      // 表单参数
      form: {
        id: null,
        categoryId: null,
        storeId: this.$route.query.storeId,
        platformId: this.$route.query.platformId,
        stockNum: null,
        goodsName: null,
        goodsImg: null,
        goodsContent: null,
        search: null,
        integral: null,
        createTime: null,
      },
      // 表单校验
      rules: {
        categoryId: [
          { required: true, message: "类目不能为空", trigger: "change" },
        ],
        goodsName: [
          { required: true, message: "商品名称不能为空", trigger: "blur" },
        ],
        goodsContent: [
          { required: true, message: "商品详情不能为空", trigger: "change" },
        ],
        goodsImg: [
          { required: true, message: "商品照片不能为空", trigger: "change" },
        ],
        stockNum: [
          { required: true, message: "商品库存量不能为空", trigger: "blur" },
        ],
        integral: [
          { required: true, message: "积分不能为空", trigger: "blur" },
        ],
        onsaleTime: [
          { required: true, message: "上架时间不能为空", trigger: "blur" },
        ],
        integral: [
          { required: true, message: "积分不能为空", trigger: "blur" },
        ],
      },
      taskData: {},
      taskData2: {},
      setId: [],
      setId2: "",
      goodsImg: "",
      storeId: "",
      fileList: [],
      picList: [],
      storeName: "",
    };
  },
  created() {
    this.getList();
    this.getCategory();
    console.log(this.$route.query.url); // 根路径
    this.getStoreInfo();
  },
  methods: {
    // 获取店铺信息
    getStoreInfo() {
      var that = this;
      $.ajax({
        type: "get",
        url: that.$route.query.url + "/pointsMall/storeInfo",
        data: { storeId: that.$route.query.storeId },
        success: function (res) {
          that.storeName = res.data.name;
        },
      });
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      this.picList.push(res.data);
      console.log(this.picList, " this.picList");
      return false;
    },
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    handleRemove(file, fileList) {
      for (const i in this.picList) {
        if (this.picList[i] === file.url) {
          this.picList.splice(i, 1);
        }
        if (file.response != undefined) {
          if (this.picList[i] === file.response.picurl) {
            this.picList.splice(i, 1);
          }
        }
      }
    },

    /** 获取类目 下拉选 */
    async getCategory() {
      const res = await listTableCategory({
        pageNum: 1,
        pageSize: 999,
        platformId: this.$route.query.platformId,
      });
      this.CategoryList = res.data.list;
    },
    /** 查询商品列表 */
    getList() {
      this.loading = true;
      listTable(this.queryParams).then((response) => {
        this.tableList = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        categoryId: null,
        storeId: this.$route.query.storeId,
        platformId: this.$route.query.platformId,
        stockNum: null,
        goodsName: null,
        goodsImg: null,
        goodsContent: null,
        search: null,
        integral: null,
        createTime: null,
      };
      this.resetForm("form");
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.fileList = [];
      this.picList = [];
      this.reset();
      this.open = true;
      this.title = "添加商品";
    },
    /** 详情按钮操作 */
    handlesee(row) {
      this.reset();
      this.fileList = [];
      this.picList = [];
      this.form = Object.assign({}, row);
      this.open = true;
      this.title = "详情";
      if (row.goodsImg != "") {
        this.picList = row.goodsImg.split(",");
        this.picList.forEach((map) => {
          var url = map;
          this.fileList.push({ url });
        });
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.fileList = [];
      this.picList = [];
      this.form = Object.assign({}, row);
      this.open = true;
      this.title = "修改商品";
      if (row.goodsImg != "") {
        this.picList = row.goodsImg.split(",");
        this.picList.forEach((map) => {
          var url = map;
          this.fileList.push({ url });
        });
      }
    },
    /** 提交按钮 */
    submitForm() {
      if (this.picList && Array.isArray(this.picList)) {
        this.form.goodsImg = this.picList.join(",");
      }
      this.form.search = this.form.search + "," + this.storeName;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateTable(this.form).then((response) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.open = false;
              this.getList();
            });
          } else {
            addTable(this.form).then((response) => {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    // 保存并录入下一条
    anotherHandle() {
      if (this.picList && Array.isArray(this.picList)) {
        this.form.goodsImg = this.picList.join(",");
      }
      this.form.search = this.form.search + "," + this.storeName;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateTable(this.form).then((response) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.getList();
              this.reset();
              this.fileList = [];
              this.picList = [];
            });
          } else {
            addTable(this.form).then((response) => {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.getList();
              this.reset();
              this.fileList = [];
              this.picList = [];
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      // this.$modal;
      this.$confirm("是否确认删除该商品？", {
        type: "warning",
      })
        .then(function () {
          return delTable(ids);
        })
        .then(() => {
          this.getList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        "system/table/export",
        {
          ...this.queryParams,
        },
        `table_${new Date().getTime()}.xlsx`
      );
    },
  },
};
</script>
<style scoped>
.isRuturn /deep/ .el-radio__label {
  font-size: 14px;
}

/deep/ .el-drawer {
  overflow-y: auto;
}
</style>
